import { CertificationCourse } from '@common/enums/certification.enums'

export const CERTIFICATION_COURSES = [
	CertificationCourse.SBEX_LOW_PRESSURE,
	CertificationCourse.SBEX_HIGH_PRESSURE,
	CertificationCourse.SBEX_MPI,
	CertificationCourse.SBEX_PHASTITE,
	CertificationCourse.HALF_DAY_SBEX_LOW_PRESSURE,
	CertificationCourse.HALF_DAY_SBEX_HIGH_PRESSURE
]
